export var Widget;
(function (Widget) {
    // Alternative entry flows the partner can request on the landing route.
    // Absent = the default buy/sell (and kyc-only) behaviour.
    let Flow;
    (function (Flow) {
        Flow["FIAT_SETTLEMENT"] = "fiat-settlement";
    })(Flow = Widget.Flow || (Widget.Flow = {}));
})(Widget || (Widget = {}));
